import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "tailwindcss/tailwind.css"
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

Vue.config.productionTip = false

Vue.use(VueSweetalert2, {
  confirmButtonColor: '#49D06F',
  cancelButtonColor: '#ff4f4d',
  focusConfirm: false
})

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")



